module.exports = __webpack_public_path__ + "assets/img/lb2.8919e8fa.jpg";